/**
 *
 * 判断false
 * @export
 * @param {Object} option:
 * @returns
 */
export function isNull(_name) {
  if (_name === '' || _name === undefined || _name === null) return true
  return false
}

/**
 * 深拷贝
 * @export
 * @param {Object} option:
 * @returns
 */
export function deepClone(currobj) {
  if (typeof currobj !== 'object') {
    return currobj
  }
  let newobj
  if (currobj instanceof Array) {
    newobj = []
  } else {
    newobj = {}
  }
  let currQue = [currobj]
  let newQue = [newobj]
  while (currQue.length) {
    let obj1 = currQue.shift()
    let obj2 = newQue.shift()
    for (let key in obj1) {
      if (typeof obj1[key] !== 'object') {
        obj2[key] = obj1[key]
      } else {
        if (obj1[key] instanceof Array) {
          obj2[key] = []
        } else {
          obj2[key] = {}
        }
        currQue.push(obj1[key])
        newQue.push(obj2[key])
      }
    }
  }
  return newobj
}

/**
 * json对象中的数组转为字符串
 * @params Json
 * @return Json
 */
export function JsonArrayToString(jsonData) {
  Object.keys(jsonData).forEach(item => {
    if (Array.isArray(jsonData[item])) {
      jsonData[item] = jsonData[item].join(',')
    }
  })
  return jsonData
}

/**
 * 过滤 value 为空的字段
 *
 * @export
 * @param {Object} [obj={}]
 * @returns {Object}
 */
export function filterEmptyProperties(obj = {}) {
  return Object.keys(obj).reduce((preObj, curKey) => {
    if (obj[curKey] !== '' && obj[curKey] != null) {
      preObj[curKey] = obj[curKey]
    }
    return preObj
  }, {})
}

/**
 *
 * select过滤
 * @export
 * @param {Object} option:
 * @params val 选中值
 * @params list{Array} 数组
 * @params key{string} 键名
 * @returns 选中的对象
 */
export function filterArray(val, list, key) {
  if (!isNull(val) && !isNull(list) && !isNull(key)) {
    return list.find(cur => cur[key] === val)
  }
  return ''
}

/**
 * 类似于Object.assign obj1中没有的键值不会被拷贝
 *
 * @export
 * @param {*} obj1
 * @param {*} obj2
 * @returns
 */
export function ObjectAssignSingle(obj1, obj2) {
  if (typeof obj1 !== 'object') {
    return obj2
  } else if (obj1 instanceof Array && obj2 instanceof Array) {
    return obj2
  } else {
    let obj1Key = Object.keys(obj1)
    let obj2Key = Object.keys(obj2)
    obj1Key.forEach(key1 => {
      obj2Key.forEach(key2 => {
        if (key1 === key2) {
          // ObjectAssignSingle(obj1[key1],obj2[key2])
          if (typeof obj1[key1] !== 'object') {
            obj1[key1] = obj2[key2]
          } else if (obj1 instanceof Array && obj2 instanceof Array) {
            obj1[key1] = obj2[key2]
          } else {
            ObjectAssignSingle(obj1[key1], obj2[key2])
          }
        }
      })
    })
  }
}

/**
 * 获取控制台菜单展示的pin
 * @export
 * @param {Object} option:
 * @returns
 */
export function getMenuPin() {
  try {
    let menuDom = document.getElementsByClassName('topNaviLink')
    if (menuDom && menuDom.length > 0) {
      let pinDom = menuDom[menuDom.length - 1].children
      return pinDom[0].innerText
    }
    return 0
  } catch (err) {
    console.log(err)
  }
}

/**
 *
 * date
 * @export
 * @param {Object} option:
 * @param kms 时间值
 * @param format 间隔符
 * @returns
 */

export function getDate(kms, format) {
  if (isNull(kms)) return {}
  format = isNull(format) ? '-' : format
  kms = isNaN(Number(kms)) ? kms : Number(kms)
  let dateObj = {}
  let dates
  if (typeof kms === 'string') {
    dates =
      kms.indexOf('-') >= 0 ? new Date(kms.replace(/-/g, '/')) : new Date(kms)
  } else {
    dates = new Date(kms)
  }
  dateObj.yr = dates.getFullYear()
  dateObj.mth = dates.getMonth() + 1
  dateObj.mth = dateObj.mth < 10 ? '0' + dateObj.mth : dateObj.mth
  dateObj.dt = dates.getDate()
  dateObj.dt = dateObj.dt < 10 ? '0' + dateObj.dt : dateObj.dt
  dateObj.tm = dates.getHours()
  dateObj.tm = dateObj.tm < 10 ? '0' + dateObj.tm : dateObj.tm
  dateObj.mn = dates.getMinutes()
  dateObj.mn = dateObj.mn < 10 ? '0' + dateObj.mn : dateObj.mn
  dateObj.sm = dates.getSeconds()
  dateObj.sm = dateObj.sm < 10 ? '0' + dateObj.sm : dateObj.sm
  dateObj.YM = dateObj.yr + '年' + dateObj.mth + '月'
  dateObj.MD = dateObj.mth + '月' + dateObj.dt + '日'
  dateObj.md = dateObj.mth + format + dateObj.dt
  dateObj.YMD = dateObj.yr + '年' + dateObj.MD
  dateObj.ymd = dateObj.yr + format + dateObj.md
  dateObj.hm = dateObj.tm + ':' + dateObj.mn
  dateObj.hms = dateObj.hm + ':' + dateObj.sm
  dateObj.txt_MDHM = dateObj.MD + ' ' + dateObj.hm
  dateObj.txt_MDHMS = dateObj.MD + ' ' + dateObj.hms
  dateObj.txt_YMDHM = dateObj.YMD + ' ' + dateObj.hm
  dateObj.txt_YMDHMS = dateObj.YMD + ' ' + dateObj.hms
  dateObj.txt_mdhm = dateObj.md + ' ' + dateObj.hm
  dateObj.txt_ymdhm = dateObj.ymd + ' ' + dateObj.hm
  dateObj.txt_ymdhms = dateObj.ymd + ' ' + dateObj.hms
  dateObj.txt_ymd = dateObj.ymd
  return dateObj
}

export function objectToArray(obj, valueIsNumber) {
  let arr = []
  for (let index in obj) {
    let value = valueIsNumber ? parseInt(index) : index
    arr.push({
      value: value,
      label: obj[index]
    })
  }
  return arr
}

/**
 *CST格式的时间 GMT格式时间代表格林威治时间 java转换的是美国时间，西六区，而前端转换的是中国时间东八区，相差14个时区
 **/
export function getTaskTime(strDate) {
  if (typeof strDate === 'string') {
    return strDate
  }
  var date = new Date(strDate)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  var d = date.getDate()
  d = d < 10 ? '0' + d : d
  var h = date.getHours()
  h = h < 10 ? '0' + h : h
  var s = date.getSeconds()
  s = s < 10 ? '0' + s : s
  var minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  var str = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
  return str
}
